<header class="side-panel__header">
  <ng-content select="[sidePanelHeader]" />
</header>

<div class="side-panel__content">
  <ng-content select="[sidePanelContent]" />
</div>

<footer class="side-panel__footer">
  <ng-content select="[sidePanelFooter]" />
</footer>
